// BUNDLED: pdp-bundle.js
export default function() {
jQuery(function ($) {

	let zoomModalHelpVisible = false;

    if (window.location.hash) {
		CCRZ.pubSub.on('view:productDetailView:refresh', () => {
			try {
				let hashLocation = window.location.hash;
				hashLocation = hashLocation.split('?')[0];
				hashLocation = hashLocation.split('&')[0];
				document.querySelector(hashLocation)?.scrollIntoView();
			} catch(e) {}
		});
    }

	function sendAlgoliaClickEvent() {
		let params = CCRZ.pagevars.queryParams,
			queryId = params.qid,
			clickIndex = params.i;
		let prodId = CCRZ.detailData.jsonProductData.product.prodBean.sfid;
		if (queryId && clickIndex) {
			CCRZ.algoliaInsightsWrapper.sendEvent('clickedObjectIDsAfterSearch', {
				index: CCRZ.quickSearchParams.algoliaMainProductIndex,
				eventName: 'Product Clicked - PDP Visit (After Search)',
				queryID: queryId,
				objectIDs: [prodId],
				positions: [Number(clickIndex) + 1]
			});
		} else {
			CCRZ.algoliaInsightsWrapper.sendEvent('clickedObjectIDs', {
				index: CCRZ.quickSearchParams.algoliaMainProductIndex,
				eventName: 'Product Clicked - PDP Visit (No Search)',
				objectIDs: [prodId]
			});
		}
	}

	CCRZ.pubSub.once('view:productDetailView:created', function (viewProto) {
		sendAlgoliaClickEvent();
		viewProto._renderDesktop = viewProto.renderDesktop;
		viewProto.renderDesktop = function() {
			this._renderDesktop();
			this.renderTabbedContent();
			this.setupSwiper();
		}
		viewProto.renderReviewsFAQs = function() {
			let hasFAQs = !!CCRZ.productDetailModel.get('faqData')?.length,
				hasReviews = !!CCRZ.productDetailModel.get('showReviews');
			if (hasFAQs || hasReviews) {
				let template = Handlebars.compile($('#PDP-Reviews-FAQs-Tabs').html());
				$('#PDP-Reviews-FAQs').html(template({hasFAQs, hasReviews}));
				CCRZ.pubSub.trigger('view:reviewReviews:refresh');
				CCRZ.pubSub.trigger('view:productFAQ:refresh', CCRZ.productDetailModel.get('faqData'), '#PDP-FAQs');
			}
		}
		viewProto.renderTabbedContent = function() {
			let template = Handlebars.compile($('#PDP-Tabbed-Content').html());
			if (CCRZ.detailData.tabbedContent)
				$('#PDPTabbedContent').html(template(CCRZ.detailData.tabbedContent));
		}
		viewProto.findInitialSlideIndex = function() {
			// show paper image else product image and shift slide index accordingly to pve enabled slides
			let media = this.model.attributes.mediaWrappers;
			let carouselImages = this.model.get('carouselImages');
			let imageIndex = -1;

			if (CCRZ.referral.isValidAndStored()) {
				imageIndex = carouselImages.findIndex(image => {
					return image.mediaType === 'Override';
				});
			}

			if (imageIndex < 0) {
				imageIndex = carouselImages.findIndex(image => {
					return image.mediaType === 'Paper Image' ||
						(media['Paper Image']?.[0] && image.URI === media['Paper Image'][0].URI);
				});
			}

			if (imageIndex < 0) {
				imageIndex = carouselImages.findIndex(image => {
					return image.mediaType === 'Product Image' ||
						   (media['Product Image']?.[0] && image.URI === media['Product Image'][0].URI);
				});
			}

			if (imageIndex >= 0) {
				const pveOffset = this.isPVEEnabled ? 2 : 0;
				return imageIndex + pveOffset;
			}

			return 0;
		}
		viewProto.setupSwiper = function() {
			let v = this;
			const isMobile = window.innerWidth < CCRZ.breakpoints.tablet.hi;
			v.isPVEEnabled = CCRZ.productDetailModel.attributes.product.prodBean.STEXPVEEnabled;

			const initialSlideIndex = v.findInitialSlideIndex();

			v.thumbSwiper = new Swiper('#pdpConfigThumbs', {
				spaceBetween: 8,
				freeMode: true,
				slidesPerView: 'auto',
				allowTouchMove: isMobile,
				watchSlidesProgress: true,
				loop: true,
				slideToClickedSlide: true,
				initialSlide: 0,
				slidesOffsetAfter: 4,
			});

			v.configSwiper = new Swiper('#pdpConfigSwiper', {
				spaceBetween: 1,
				navigation: {
					nextEl: '.pdp-swiper-button-next',
					prevEl: '.pdp-swiper-button-prev',
				},
				thumbs: {
					swiper: v.thumbSwiper
				},
				keyboard: {
					enabled: true,
					onlyInViewport: true,
				},
				zoom: {
					maxRatio: 2,
					toggle: true,
					panOnMouseMove: true
				},
				loop: true,
				slidesPerView: 'auto',
				allowTouchMove: isMobile,
				initialSlide: initialSlideIndex,
				slideToClickedSlide: true,
			});
			v.configSwiper.on('slideChange', function() {
				v.handleConfigSwiperSlideChange(this);
			});

			// Initialize custom swipe handler for conditional swipe behavior on 3D PVE Viewer Slide
			if (v.isPVEEnabled) {
				v.setup3DSwipeHandler();
			}

			//fix for swiper.js positioning issue when zooming on mouseenter
			//disable hover panning until zoom animation runs
			document.getElementById('pdpConfigSwiper').addEventListener('pointermove', captureMove, { capture: true });

			$('#pdpConfigSwiper .swiper-zoom-container').on('mouseenter', function (ev) {
				v.configSwiper.zoom.in(ev);
				ev.currentTarget.classList.add('zoomed');

				//resume hover panning after zoom animation
				setTimeout(() => document.getElementById('pdpConfigSwiper').removeEventListener('pointermove', captureMove, true), 200);
			});
			$('#pdpConfigSwiper .swiper-zoom-container').on('mouseleave', function (ev) {
				v.configSwiper.zoom.out();
				ev.currentTarget.classList.remove('zoomed');

				//disable hover panning until zoom animation runs
				document.getElementById('pdpConfigSwiper').addEventListener('pointermove', captureMove, { capture: true });
			});

			function captureMove(ev) {
				ev.stopPropagation();
			}

			$('.openZoomModal').click(v.openZoomModal.bind(v));
		}
		// custom swiper handler specifically for the 3D PVE viewer slide
		// allows 3D touch interaction and navigation on a "fast" swipe
		viewProto.setup3DSwipeHandler = function() {
			let v = this;
			const swiperContainer = document.getElementById('pdpConfigSwiper');

			// configuration for 3D swipe gesture detection:
			const config = {
				velocityThreshold: 800,  // velocity in pixels/second above which a swipe is considered "fast" (triggering navigation)
				minimumDistance: 75,     // minimum distance in pixels required to qualify as a swipe gesture (prevents small/accidental touches and allows those to interact with 3d experience)
				timeThreshold: 325,      // maximum duration in milliseconds for a "fast" swipe (longer swipes are considered deliberate/slow)
				horizontalRatio: 0.75     // ratio of horizontal to total movement required to qualify as a horizontal swipe / intentional swipe left or right to trigger navigation
			};

			let touchStartX = 0;
			let touchStartY = 0;
			let touchStartTime = 0;
			let isTracking = false;

			function is3DSlideActive() {
				return v.isPVEEnabled && v.configSwiper && v.configSwiper.realIndex === 1;
			}

			//calculate swipe velocity and handle navigation
			function handleTouchEnd(endX, endY, endTime) {
				if (!isTracking || !is3DSlideActive()) return;

				// determine if this gesture qualifies as a fast horizontal swipe for navigation
				const deltaX = endX - touchStartX;
				const deltaY = endY - touchStartY;
				const deltaTime = endTime - touchStartTime;
				const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
				const horizontalDistance = Math.abs(deltaX);
				const verticalDistance = Math.abs(deltaY);

				if (distance < config.minimumDistance) return;
				if (deltaTime <= 0) return;

				const velocity = (distance / deltaTime) * 1000;

				const isHorizontalDominant = horizontalDistance / (horizontalDistance + verticalDistance) >= config.horizontalRatio;

				const isFastSwipe = velocity > config.velocityThreshold &&
									deltaTime < config.timeThreshold &&
									isHorizontalDominant;

				if (isFastSwipe) {
					// fast swipe - trigger navigation
					if (deltaX > 0) {
						v.configSwiper.slidePrev();
					} else {
						v.configSwiper.slideNext();
					}
				}
			}

			function handleTouchStart(event) {
				if (!is3DSlideActive()) return;

				const touch = event.touches ? event.touches[0] : event;
				touchStartX = touch.clientX;
				touchStartY = touch.clientY;
				touchStartTime = Date.now();
				isTracking = true;
			}

			function handleTouchEndEvent(event) {
				// handle touch completion: get data and determine action
				if (!isTracking || !is3DSlideActive()) {
					isTracking = false;
					return;
				}

				const touch = event.changedTouches ? event.changedTouches[0] : event;
				const endX = touch.clientX;
				const endY = touch.clientY;
				const endTime = Date.now();

				handleTouchEnd(endX, endY, endTime);

				isTracking = false;
			}

			// ensure proper state - reset tracking for future events when browser/system takes over the gesture like pinch to zoom
			function handleTouchCancel() {
				isTracking = false;
			}

			if (swiperContainer) {
				// capture touch start position and time
				swiperContainer.addEventListener('touchstart', handleTouchStart, { capture: true, passive: true });
				// calculate velocity and trigger navigation
				swiperContainer.addEventListener('touchend', handleTouchEndEvent, { capture: true, passive: true });
				// reset tracking on touch cancel
				swiperContainer.addEventListener('touchcancel', handleTouchCancel, { capture: true, passive: true });
			}
		}
		viewProto.openZoomModal = function() {
			this.model.set('image2d', image2d);
			let headerTemplate = Handlebars.compile($("#ProductDetails-ZoomModal-Header").html()),
			headerHTML = headerTemplate(this.model.toJSON()),
			bodyTemplate = Handlebars.compile($("#ProductDetails-ZoomModal-Body").html()),
			bodyHTML = bodyTemplate(this.model.toJSON()),
			initialSlide = Math.max(this.configSwiper.realIndex - 2, 0);

			CCRZ.pubSub.trigger('view:B2C_Modal:openFullscreen', {header: headerHTML, body: bodyHTML});
			this.zoomSwiper = new Swiper('#pdpZoomSwiper', {
				spaceBetween: 100,
				pagination: {
					el: '.pdp-zoom-swiper-pagination',
					type: 'fraction',
					renderFraction: function (currentClass, totalClass) {
						return '<span class="' + currentClass + '"></span>' +
							' of ' +
							'<span class="' + totalClass + '"></span>';
					}
				},
				navigation: {
					nextEl: '.pdp-zoom-swiper-button-next',
					prevEl: '.pdp-zoom-swiper-button-prev',
				},
				allowTouchMove: false,
				zoom: {
					maxRatio: 2,
					toggle: true,
					panOnMouseMove: true
				},
				keyboard: {
					enabled: true,
					onlyInViewport: true,
				},
				initialSlide: initialSlide,
			});

			this.zoomSwiper.on('slideChange', this.handleZoomSwiperSlideChange);
			this.attachZoomModalListeners();
			this.initializeCloudinaryVideos();
		}
		viewProto.initializeCloudinaryVideos = function() {
			$.each(CCRZ.productDetailModel.attributes.carouselImages, function (index, value) {
				if (document.querySelector("video#" + value.sfid) && value.mediaType === 'PDP Video') {
					try {
						const PDPPlayer = cloudinary.videoPlayer(value.sfid, JSON.parse(value.controls));
						PDPPlayer.source(value.publicId);
					}
					catch(err) {}
				}
			});
		}
		viewProto.attachZoomModalListeners = function() {
			const delta = 5;
			let startX;
			let startY;
			$('#pdpZoomSwiper').on('pointerdown', function (ev) {
				$('.zoomModal-help').fadeOut();
				zoomModalHelpVisible = false;
				if (ev.pointerType == 'touch') return;
				startX = ev.pageX;
				startY = ev.pageY;
			});

			$('#pdpZoomSwiper').on('pointerup', function (ev) {
				if (ev.pointerType == 'touch') return;
				const diffX = Math.abs(ev.pageX - startX);
				const diffY = Math.abs(ev.pageY - startY);
				if (diffX < delta && diffY < delta) {
					if (ev.currentTarget.classList.contains('zoomed')) {
						ev.currentTarget.swiper.zoom.out();
						ev.currentTarget.classList.remove('zoomed');
					} else {
						ev.currentTarget.swiper.zoom.in(ev);
						ev.currentTarget.classList.add('zoomed');
					}
				}
			});

			$('#pdpZoomSwiper').on('mouseleave', function (ev) {
				if (ev.currentTarget.classList.contains('zoomed')) {
					ev.currentTarget.swiper.zoom.out();
					document.getElementById('pdpZoomSwiper').addEventListener('pointermove', captureMove ,{capture:true});
				}
			});

			$('#pdpZoomSwiper').on('mouseenter', function (ev) {
				if (ev.currentTarget.classList.contains('zoomed')) {
					setTimeout(function() {	document.getElementById('pdpZoomSwiper').removeEventListener('pointermove', captureMove, true) }, 200);
					ev.currentTarget.swiper.zoom.in(ev);
				}
			});

			function captureMove(ev) {
				ev.stopPropagation();
			}
		}
		viewProto.handleZoomSwiperSlideChange = function(swiper) {
			swiper.el.classList.remove('zoomed');
			if($('.zoomModal-help').is(':visible')){
				zoomModalHelpVisible = true;
			}
			else if (!this.slides[this.activeIndex].innerHTML.includes('cld-video-player') && !zoomModalHelpVisible){
				zoomModalHelpVisible = false;
			}
			if (this.slides[this.activeIndex].innerHTML.includes('cld-video-player')) {
				$('.zoomModal-help').fadeOut();
			}
			else if (zoomModalHelpVisible) {
				$('.zoomModal-help').fadeIn();
			}
		}
		viewProto.handleConfigSwiperSlideChange = function(swiper) {
			let v = this;
			if (!v.isPVEEnabled) return;

			const is3DSlide = swiper.realIndex === 1;

			if (is3DSlide) {
				swiper.allowTouchMove = false;
			} else {
				const isMobile = window.innerWidth < CCRZ.breakpoints.tablet.hi;
				swiper.allowTouchMove = isMobile ? true : false;
			}

			CCRZ.pubSub.trigger('pdp:swiperSlideChanged', {
				is3DSlide: is3DSlide
			});
		}
		viewProto.updateLeadTime = function() {
			let leadTimeData = this.model.get('leadTimeData');
			let leadTimeDataByCode = this.model.get('leadTimeDataByCode');
			let selectedFeatures = this.model.get('selectedFeatures');
			let selectedFeatureCodes = this.model.get('selectedFeatureCodes');
			let hasNames = leadTimeData && selectedFeatures;
			let hasCodes = leadTimeDataByCode && selectedFeatureCodes;
			if (hasNames || hasCodes) {
				let v = this;
				let featureValue;
				let maxLeadTime = v.model.attributes.product.prodBean.leadTime;
				let maxLeadFeature;
				if (hasNames) {
					_.each(_.keys(selectedFeatures), (feature) => {
						featureValue = selectedFeatures[feature].toLowerCase();
						feature = feature.toLowerCase();
						if( leadTimeData[feature] && leadTimeData[feature][featureValue] > maxLeadTime ) {
							maxLeadTime = leadTimeData[feature][featureValue];
							maxLeadFeature = feature;
						}
					});
				}
				// Catalog feature names can differ from the spec, so also match on codes and
				// keep whichever lead time is longer.
				if (hasCodes) {
					_.each(_.keys(selectedFeatureCodes), (featureCode) => {
						let valueCode = String(selectedFeatureCodes[featureCode]).toLowerCase();
						let code = String(featureCode).toLowerCase();
						if( leadTimeDataByCode[code] && leadTimeDataByCode[code][valueCode] > maxLeadTime ) {
							maxLeadTime = leadTimeDataByCode[code][valueCode];
							maxLeadFeature = code;
						}
					});
				}
				v.model.set('currentLeadTime', maxLeadTime);
				$('.js-leadTime').html(`${Handlebars.helpers.formatLeadTime(maxLeadTime)}`);
			}
		}
		viewProto.updateCarbonNeutral = function() {
			let carbonNeutralData = this.model.get('carbonNeutralData');
			let carbonNeutralDataByCode = this.model.get('carbonNeutralDataByCode');
			let selectedFeatures = this.model.get('selectedFeatures');
			let selectedFeatureCodes = this.model.get('selectedFeatureCodes');
			let hasNames = carbonNeutralData && selectedFeatures;
			let hasCodes = carbonNeutralDataByCode && selectedFeatureCodes;
			if (hasNames || hasCodes) {

				let featureValue,
				isCarbonNeutral,
				hasQualifyingFeature = false,
				hasDisqualifyingFeature = false;

				if (hasNames) {
					_.each(_.keys(selectedFeatures), (feature) => {
						featureValue = selectedFeatures[feature].toLowerCase();
						feature = feature.toLowerCase();
						if (carbonNeutralData[feature]) {
							if (carbonNeutralData[feature].includes(featureValue)) {
								hasQualifyingFeature = true;
							} else {
								hasDisqualifyingFeature = true;
							}
						}
					});
				}
				// Catalog feature names can differ from the spec, so also match on codes.
				if (hasCodes) {
					_.each(_.keys(selectedFeatureCodes), (featureCode) => {
						let valueCode = String(selectedFeatureCodes[featureCode]).toLowerCase();
						let code = String(featureCode).toLowerCase();
						if (carbonNeutralDataByCode[code]) {
							if (carbonNeutralDataByCode[code].includes(valueCode)) {
								hasQualifyingFeature = true;
							} else {
								hasDisqualifyingFeature = true;
							}
						}
					});
				}

				isCarbonNeutral = hasQualifyingFeature && !hasDisqualifyingFeature;
				if (isCarbonNeutral) {
					$('.js-carbon-neutral').show();
				} else {
					$('.js-carbon-neutral').hide();
				}

				this.model.set('isCarbonNeutral', isCarbonNeutral);
			}
		}
		viewProto.setCarouselData = function() {
			const v = this;
			let media = this.model.attributes.mediaWrappers;
			let carouselImages = [];
			let heroImageOverride;

			if (CCRZ.referral.isValidAndStored()) {
				let overrideURI = CCRZ.detailData.referralOptions?.[sessionStorage.getItem('referralCode')]?.heroImageOverride;
				if (overrideURI) {
					heroImageOverride = {
						URI: overrideURI,
						mediaType: 'Override'
					};
				}
			}

			carouselImages.push(heroImageOverride ?? media['Paper Image']?.[0] ?? media['Product Image']?.[0]);
			carouselImages.push(media['Gallery Image']);
			carouselImages.push(media['PDP Video']);
			carouselImages.push(getTabbedContentImages());
			carouselImages.push(media['Alternate Images']);

			carouselImages = carouselImages.flat().filter((el) => el && el.URI && (el.mediaType != 'PDP Video' || el.controls));
			this.model.set('carouselImages', carouselImages);

			function getTabbedContentImages() {
				if (!CCRZ.detailData.tabbedContent) return [];
				const tabbedContentImages = [];
				for (let i = 1; CCRZ.detailData.tabbedContent[`Feature_Image_${i}__c`]; i++) {
					tabbedContentImages.push({
						URI: CCRZ.detailData.tabbedContent[`Feature_Image_${i}__c`],
						altMessage: CCRZ.detailData.tabbedContent[`Feature_Title_${i}__c`],
						mediaType: 'Feature'
					});
				}
				tabbedContentImages.push({
					URI: CCRZ.detailData.tabbedContent['Measurement_Image__c'],
					altMessage: 'Measurements',
					mediaType: 'Measurements'
				});
				return tabbedContentImages;
			}
		}
		viewProto.init = function() {
			var v = this;
			this.pickerView = _.isUndefined(CCRZ.views.wishlistPickerModal)?false:(new CCRZ.views.wishlistPickerModal());
			this.pageSections = CCRZ.pageSectionsList;
			this.relatedData  = CCRZ.relatedModel;
			this.productAttributes = new CCRZ.collections.ProductAttributesCollection();
			this.setAttributePrices();
			this.setCarouselData();
			this.isInStock = !(this.model.attributes?.product?.prodBean?.stockedProduct);

			let prodData = CCRZ.detailData.b2ProductDataFields;
			v.model.set('showReviews', prodData.B2_Product_Data__r.Show_Reviews__c);
			v.model.set('reviewsId', prodData.B2_Product_Data__r.Reviews_ID__c);
			v.model.set('B2productMessageTitle', prodData.B2_Product_Data__r.Product_Message_Title__c);
			v.model.set('B2productMessageIcon', prodData.B2_Product_Data__r.Product_Message_Icon__c);
			v.model.set('B2productMessageRT', prodData.B2_Product_Data__r.Product_Message_RT__c);
			v.model.set('B2productMessage', prodData.B2_Product_Data__r.Product_Message__c);
			v.model.set('B2productMessageBackgroundColor', prodData.B2_Product_Data__r.Product_Message_Background_Color__c);
			let qtyMax = prodData.B2_Product_Data__r.Quantity_Selector_Max__c || CCRZ.pagevars.pageConfig['c.productlimit'];
			v.model.set('quantitySelectorMax', qtyMax);
			v.model.set('featureDisplayOptions', CCRZ.detailData.featureDisplayOptions);
			v.model.set('referralOptions', CCRZ.detailData.referralOptions);
			v.model.set('fabricFamilyData', CCRZ.detailData.fabricFamilyData);
			v.model.set('showFrequentlyBoughtTogether', prodData.B2_Product_Data__r.Show_Frequently_Bought_Together__c);

			v.render();

			const className = 'B2C_ProductDetailPageController';
			let prodDataId = this.model.attributes.product.prodBean.b2ProductData;

			CCRZ.makeRemoteAction(className, 'getPDPInitData', prodDataId).then(
				function(data) {
					if (data.quickInfoIcons) {
						v.model.set('quickInfoIcons', data.quickInfoIcons);
						CCRZ.renderHandlebars('ProductDetails-QuickInfoIcons', data.quickInfoIcons, '#quickInfoIcons');
					}

					if (data.leadTimeAndCarbonNeutralData) {
						v.model.set('carbonNeutralData', data.leadTimeAndCarbonNeutralData.carbonNeutral);
						v.model.set('carbonNeutralDataByCode', data.leadTimeAndCarbonNeutralData.carbonNeutralByCode);
						v.model.set('leadTimeData', data.leadTimeAndCarbonNeutralData.leadTimes);
						v.model.set('leadTimeDataByCode', data.leadTimeAndCarbonNeutralData.leadTimesByCode);
						v.updateLeadTime();
						v.updateCarbonNeutral();
					}

					if (data.stockData) {
						v.model.set('stockData', data.stockData);
					}

					if (data.productFAQs) {
						v.model.set('faqData', data.productFAQs);
						CCRZ.util.generateFAQRichResults(data.productFAQs, CCRZ.productDetailModel.attributes.product.prodBean.name);
					}
				},
				function(error) {
					console.error('Error loading PDP init data', error);
				}
			).finally(function() {
				v.renderReviewsFAQs();
			});
		}

		viewProto.checkStock = function (selectedFeatures) {
			let match;
			let inStock = true;
			if (this.model.get('stockData') && Object.keys(selectedFeatures)) {
				let variantsList = this.model.get('stockData').variantsList;
				match = _.findWhere(variantsList, selectedFeatures);
				if (match && match.outOfStock) {
					inStock = false;
				} else {
					let featureValuesList = this.model.get('stockData').featureValuesList;
					let featureKeys = [];
					Object.keys(selectedFeatures).forEach(function (featureKey) {
						featureKeys.push(featureKey);
					})
					if (featureValuesList) {
						let shouldSkip = false;
						Object.keys(featureValuesList).forEach(function (key) {
								if (shouldSkip) {
									return;
								}
								for (let i = 0; i < featureKeys.length; i++) {
									let feature = featureKeys[i];
									if (featureValuesList[key][feature]) {
										if (featureValuesList[key][feature] && selectedFeatures[feature] == featureValuesList[key][feature]) {
											inStock = !featureValuesList[key]['outOfStock'];
											if (featureValuesList[key]['outOfStock']) {
												shouldSkip = true;
												return;
											}
										}
									}
								}
							})
					}

						// Also check by code, since names can drift from the configurator spec.
						let featureValuesByCode = this.model.get('stockData').featureValuesByCode;
						let selectedFeatureCodes = this.model.get('selectedFeatureCodes');
						if (featureValuesByCode && selectedFeatureCodes) {
							Object.keys(selectedFeatureCodes).forEach(function (featureCode) {
								let valueCode = String(selectedFeatureCodes[featureCode]).toLowerCase();
								let code = String(featureCode).toLowerCase();
								if (featureValuesByCode[code] && featureValuesByCode[code][valueCode]) {
									inStock = false;
								}
							});
						}
				}
			this.isInStock = inStock;
			return inStock;
		}
	}

	viewProto.findInStockConfig = function() {
		let inStockVariant;
		let variantsList = this.model.get('stockData')?.variantsList;
		if (variantsList) {
			for (let variant of variantsList) {
				if (!variant.outOfStock) {
					inStockVariant = {...variant};
					delete inStockVariant.outOfStock;
					break;
				}
			}
		}
		return inStockVariant;
	}
	});

	// ENHANCED PDP PRODUCT DETAILS OVERLAY FIXED POSITION ON SCROLL -->
	$(function() {
		$(document).scroll(function() {
			let $productDetailsOverlay = $(".product-details--overlay");
			$productDetailsOverlay.css({ top: CCRZ.fixedHeaderHeight }); // DESKTOP VIEW
		});
	});
});
}
